import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useFlightData = () => {
    const getFlightData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}flight${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postFlightData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}flight${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}flight${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putFlightData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}flight${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchFlightData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}flight${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteFlightData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}flight${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getFlightData,
        postFlightData,
        putFlightData,
        patchFlightData,
        deleteFlightData
    };

};